var render, staticRenderFns
import script from "./CarbonAds.vue?vue&type=script&lang=js"
export * from "./CarbonAds.vue?vue&type=script&lang=js"
import style0 from "./CarbonAds.vue?vue&type=style&index=0&id=4109f67d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4109f67d",
  null
  
)

export default component.exports